var React = require('react');

function IconPlusThin (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#create-new-create-new)","key":0},React.createElement("path",{"fill":"currentColor","d":"M240 32c0-17.7-14.3-32-32-32s-32 14.3-32 32v144H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h144v144c0 17.7 14.3 32 32 32s32-14.3 32-32V240h144c17.7 0 32-14.3 32-32s-14.3-32-32-32H240V32Z"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"create-new-create-new"},React.createElement("path",{"fill":"currentColor","d":"M0 0h416v416H0z"})))]);
}

IconPlusThin.defaultProps = {"fill":"currentColor","viewBox":"0 0 416 416"};

module.exports = IconPlusThin;

IconPlusThin.default = IconPlusThin;
